module.exports = __webpack_public_path__ + "static/media/login.e0e00361.jpg";